export default __webpack_public_path__ + "static/1-b16211669eb1c8e6096429f27a05bfbc.jpg";